module.exports = __webpack_public_path__ + "img/Lego_Kids_sk.03a38a4a.png";